import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as History } from '@styles/icons/history.svg';
import React from 'react';

export const HistoryIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={History} viewBox={'0 0 21 21'} />
);

export default HistoryIcon;
